<template>
  <div>
    <DownloadAds v-if="isPC" />
    <DownloadAdsMobile v-else />
  </div>
</template>

<script>
import DownloadAds from './DownloadAds.vue';
import DownloadAdsMobile from './DownloadAdsMobile.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'DownloadAdsWrapper',
  components: {
    DownloadAds,
    DownloadAdsMobile
  },
  computed: {
    ...mapGetters(['deviceType']),
    isPC () {
      return this.deviceType != 'mobile'
    }
  }
};
</script> 